// extracted by mini-css-extract-plugin
export var brand = "_ag-9";
export var compact = "_ag-6";
export var extraSmall = "_ag-7";
export var icon = "_ag-0";
export var large = "_ag-4";
export var light = "_ag-1";
export var medium = "_ag-5";
export var outline = "_ag-b";
export var primaryDark = "_ag-a";
export var primaryLight = "_ag-8";
export var primaryModern = "_ag-c";
export var success = "_ag-2";
export var successSolid = "_ag-3";